import { App_User } from '@/data/user_info'
export default {
    data() {
        return {
            auth_phone_params: {}
        }
    },
    onLoad({building_id}) {
        this.auth_phone_params = {
            scene: '价值分析报告',
            targetable_type: 'Fc::Building',
            targetable_id: building_id
        }
    },
    methods: {
        async checkVip() {
            const { is_vip, is_consultant } = await App_User.fetchUser()
            this.show_vip_pop_box = !is_vip && !is_consultant
            return this.show_vip_pop_box
        }
    }
}